import React from 'react'

// どういうわけか npm の use-constant が Remix から参照できないので自作
export function useConstant<T>(fn: () => T): T {
  const ref = React.useRef<{ v: T }>()
  if (!ref.current) {
    ref.current = { v: fn() }
  }
  return ref.current.v
}
